// Auditoria — append-only, e é isso que a torna útil.
//
// Responde "quem validou isso, e quando?" meses depois. Só responde se
// ninguém puder reescrever a história, e é por isso que a tabela tem trava de
// imutabilidade no banco em vez de disciplina no código.

import { useQuery } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { obter, type Auditoria as Linha } from "../api.js";
import { Carregando, Falha, quando, Vazio } from "../pecas/basicos.js";

const ROTULO: Record<string, string> = {
  validar_lote: "validou em lote",
  promover_versao: "promoveu versão",
  publicar_colecao: "publicou coleção",
  upload_arquivo: "subiu arquivo",
  limpar_staging: "limpou staging",
  alterar_agendamento: "alterou agendamento",
};

export function Auditoria(): ReactNode {
  const a = useQuery({ queryKey: ["auditoria"], queryFn: () => obter<Linha[]>("/auditoria") });
  if (a.isLoading) return <Carregando />;
  if (a.error) return <Falha erro={a.error} />;
  const lista = a.data ?? [];
  if (lista.length === 0) return <Vazio>Nada registrado ainda.</Vazio>;

  return (
    <div className="rolagem">
      <table className="tabela">
        <thead>
          <tr>
            <th>Quando</th>
            <th>Ator</th>
            <th>Ação</th>
            <th>Alvo</th>
            <th>Detalhe</th>
          </tr>
        </thead>
        <tbody>
          {lista.map((l, i) => (
            <tr key={`${l.criado_em}-${i}`}>
              <td className="mono">{quando(l.criado_em)}</td>
              <td>{l.ator}</td>
              <td>{ROTULO[l.acao] ?? l.acao}</td>
              <td className="mono discreto">{l.alvo ?? "—"}</td>
              <td className="discreto mono" style={{ fontSize: 11 }}>
                {l.detalhe ? JSON.stringify(l.detalhe) : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
